import { trackCheckoutProgress } from '../../../../../../shared/analytics/e-commerce/trackCheckoutProgress';
import { CheckoutSteps } from './CheckoutSteps';

export function trackViewDetails() {
	trackCheckoutProgress({ step: CheckoutSteps.PersonalDetails });
}
